import mixpanel from 'mixpanel-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { TokenInterceptor } from '@unico-people/utils-interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';

import * as Sentry from "@sentry/angular";
import { SegmentModule } from 'ngx-segment-analytics';
import { environment } from '@unico-people/benefits-form/enviroment';
import { Router } from "@angular/router";
import { MatDialogModule } from '@angular/material/dialog';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import * as ldSdk from 'launchdarkly-js-client-sdk';
import { LDMultiKindContext } from 'launchdarkly-js-client-sdk';
import { getTokenStorage } from '@unico-people/shared/utils/storage';

export function tokenGetter() {
  return   getTokenStorage();
}

const context = {
  anonymous: true,
  custom: {
     "appName": "form-benefits"
  },
} as ldSdk.LDContext;


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatSnackBarModule,
    SegmentModule.forRoot({ apiKey: '', debug: false, loadOnInitialization: false }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    MatDialogModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    { provide: LaunchdarklyService, useFactory: () => new LaunchdarklyService(environment.launchDarklyClientId)},
    {
      provide: APP_INITIALIZER,
      useFactory: (ld: LaunchdarklyService) => async() => {
        // todo: use organization and positionId to set ld contextt
        await ld.init({ context });

        mixpanel.init(
          environment.mixpanel_token,
          { debug: !environment.production, track_pageview: true, persistence: 'localStorage' }
        )
      },
      multi: true,
      deps: [LaunchdarklyService],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
